import { makeStyles } from '@material-ui/core/styles'
import AccountDetailView from './AccountDetailView'
import AccountDetailAdmin from './AccountDetailAdmin'

const AccountDetail = ({
  key,
  admin,
  index,
  editMode,
  data,
  label,
  formikProps,
  className
}) => {
  const classes = useStyles({ admin, index })

  const viewSwitcher = () => {
    if (admin) {
      return (
        <AccountDetailAdmin
          data={data}
          className={`${className} ${classes.root}`}
        />
      )
    }
    return (
      <AccountDetailView
        data={data}
        className={`${className} ${classes.root}`}
      />
    )
  }

  return viewSwitcher()
}

export default AccountDetail

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    height: '100%',
    gridColumn: 'span 4',
    gridRow: 'span 4',
    display: 'flex',
    alignItems: 'center'
  },
  dataDiv: {
    marginLeft: 20
  },
  accountName: {
    color: theme.palette.primary.accent
  }
}))
